// extracted by mini-css-extract-plugin
export default {"form":"UserForm_form__ZI8Rs","label":"UserForm_label__39NBX"};